import React, { useState } from 'react'
import Accordion from '@material-ui/core/Accordion'
import AccordionDetails from '@material-ui/core/AccordionDetails'
import AccordionSummary from '@material-ui/core/AccordionSummary'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'

import Paths from '../../utils/paths'

export default function FAQs() {
  const [expanded, setExpanded] = useState({
    wage: false,
    prepaid: false,
    payroll: false,
    discounts: false,
    cashback: false
  })

  const handleChange = section => panel => (event, isExpanded) => {
    setExpanded(prev => ({ ...prev, [section]: isExpanded ? panel : false }))
  }

  const sections = [
    { title: 'Earned Wage Access', key: 'wage', content: wageAccessAcordionContent },
    { title: 'Prepaid Card', key: 'prepaid', content: prepaidCardAcordionContent },
    { title: 'Payroll Card', key: 'payroll', content: payrollCardAcordionContent },
    { title: 'Discounts', key: 'discounts', content: discountsAcordionContent },
    { title: 'Cashback', key: 'cashback', content: cashbackAcordionContent }
  ]

  const renderSection = ({ title, key, content }) => (
    <>
      <h2 className='web-subhead pt-5 pb-3 mt-5'>{title}</h2>
      {content.map((e, index) => {
        const panelId = `${key}-panel${index}`
        return (
          <Accordion
            key={panelId}
            className='accordion-item-faqs'
            expanded={expanded[key] === panelId}
            onChange={handleChange(key)(panelId)}
          >
            <AccordionSummary
              // expandIcon={<ArrowForwardIosOutlinedIcon />}
              expandIcon={<KeyboardArrowDownIcon color='#000'/>}
              aria-controls={`${panelId}-content`}
              id={`${panelId}-header`}
            >
              <div className='accordion-title'>{e.question}</div>
            </AccordionSummary>
            <AccordionDetails className='accordion-details-column'>
              <div className='accordion-text'>{e.answer}</div>
              {e.disclaimer && (
                <div className='accordion-text disclaimer-text'>{e.disclaimer}</div>
              )}
            </AccordionDetails>
          </Accordion>
        )
      })}
    </>
  )

  return (
    <div className='px-1 px-md-5 pb-5'>
      <div className='row p-5 px-3 px-sm-5'>
        <h1 className='web-header text-center pb-5'>Frequently Asked Questions</h1>
        {sections.map(section => (
          <React.Fragment key={section.key}>{renderSection(section)}</React.Fragment>
        ))}
      </div>
    </div>
  )
}

const discountsAcordionContent = [
  {
    question: 'How to do a merchant and offer search?',
    answer: (
      <>
        Offers are categorized by location so that search results depend on where the user is
        located.
        <br />
        <br />
        By default, smartphones and browsers obtain the geo-data required to run queries on mobile
        and desktop devices. In addition, member-supplied data such as zip code and address are used
        to customize offers.
      </>
    )
  },
  {
    question: 'How do I search by category?',
    answer: (
      <>
        Each user can make a better search by selecting from the menu bar options such as “Dining”
        or “Shopping” and then selecting the subcategory or area of interest.
      </>
    )
  },
  {
    question: 'How do I redeem an offer or coupon?',
    answer: (
      <>
        Once you find a coupon that you’d like to use, there are three ways in which you can redeem
        it, and each offer may have one or more options.
        <br />
        <br />
        Mobile - Click on “Use Coupon Now”. You will be asked if you are ready to redeem the mobile
        coupon. Click “Yes” and the coupon will appear on your screen. In some cases, a bar code
        will be displayed that can be scanned by the merchant. In other cases, a code will appear
        that you need to give to the merchant so that they apply the offer to your purchase.
        <br />
        <br />
        Print - Click on “Print for later”. This will take you to a page where you can print your
        coupon and redeem it by bringing it with you when you visit the merchant and make a
        purchase.
        <br />
        <br />
        Click URL - Click on “Website Coupon”. You will be shown a code that has to be inputted
        when asked while setting up your payment information on the merchant website.
        <br />
        <br />
        Make sure you have pop-ups and redirects enabled!
      </>
    )
  },
  {
    question: 'How do I report an issue with a coupon or merchant?',
    answer: (
      <>
        Please call our Customer Support line at 1-866-995-2736 and our agents will assist.
      </>
    )
  }
]

const wageAccessAcordionContent = [
  {
    question: 'Does my employer know about my Earned and Auto Wage Access requests?',
    answer: (
      <>
        We work directly with your HR and Payroll Departments to communicate the wage access request. These requests are then deducted from the paycheck issued by your company on your next payroll. We encourage you to reach out to your HR representative and inquire who will know within your company.
      </>
    )
  },
  {
    question: 'How much money can I request in a single transaction?',
    answer: (
      <>
        Generally, you can request up to 100% of your net earned wages since your last pay date. Within a single pay period, there is not a maximum number of requests you can make; however, your available amount for request will be capped at 100% of your currently net earned wages since your last pay date, or $500 per transaction. Please note that every employer can set limits to the percentage of earned wages that a user can request per transaction and to the number of requests per pay period.
      </>
    )
  },
  {
    question: 'Is there a limit on the number of Earned Wage Access requests that I make in a single pay period?',
    answer: (
      <>
        There is not a maximum number of requests you can make during the same pay period. You can make as many requests as you would like if there is balance available on your account. Please note that an Auto Wage Access requires a minimum balance of $10 USD per transaction.
      </>
    )
  },
  {
    question: 'When will the funds be available in my account?',
    answer: (
      <>
        When you make an Earned Wage Access request, you will be required to select when you want to receive the funds. You can choose to receive the funds in 1-3 business days, or an instant option where you will see the funds within one hour of your request.
        <br />
        <br />
        Auto Wage Access allows you to decide when you want to receive your Earned Wage Access. You can set up or modify the frequency and amount that you want to be receiving during a pay period. 
      </>
    )
  },
  {
    question: 'How and when is my Wage Access Repaid?',
    answer: (
      <>
        There is no action you need to take or do.
        <br />
        <br />
        We are in direct communication with your Payroll Department. This allows us to stay up to date with requests made during each pay period. Your employer will process a deduction from your paycheck for the total amount that was advanced including transaction fees.
      </>
    )
  },
  {
    question:
      'Do I need a bank account or card to request an Earned Wage Access? ',
    answer: (
      <>
        You can select to have the funds transferred onto your personal debit card or bank account, but if you do not have one, you may apply for a Multikrd Prepaid Card or may receive a Multikrd Payroll Card from your employer that you can use for Earned Wage Access.
      </>
    ),
    disclaimer: '*Central Bank of Kansas City does not administer nor is liable for Pay on-demand/earned waged access or tips access. '
  }
]

const cashbackAcordionContent = [
  {
    question: 'How does the cashback service work?',
    answer: (
      <>
        Our platform allows you to earn cash rewards while shopping online. Through a network of
        affiliate businesses, we offer customers the possibility to shop with nearly 8,000 U.S.
        online retailers.
        <br />
        <br />
        Browse through the “Cash Back” section under rewards and explore all the saving
        opportunities available to you. Once you find an attractive offer, click on “Shop Now” and
        you will be redirected to the merchant’s website. Our technology will track your purchase,
        and we will be able to reward you the amount of cash back that the merchant offers you.
        Please note that if you open the merchant’s website separately, you will not be awarded
        cashback. Cashback is earned only on eligible purchases initiated using this platform.
      </>
    )
  },
  {
    question: 'Will I be charged for this service?',
    answer: <>No. Cashback opportunities are part of your membership and can be enjoyed for free.</>
  },
  {
    question: 'How much cashback will I receive?',
    answer: (
      <>
        You can receive up to 30% cashback on participating stores. Each store has unique offers,
        and not all purchases are eligible for cashback. Each store reserves the right to exclude
        certain products or services from eligibility.
      </>
    )
  },
  {
    question: 'What is the difference between “Available” “Pending” and “Historic” cashback?',
    answer: (
      <>
        “Pending” status indicates that a transaction has been tracked, and it is in the process of
        being verified (and approved) by the brand.
        <br />
        <br />
        “Available” means that we have received the cash back rewards from the retailer, and you may
        now withdraw, use it or donate it.
        <br />
        <br />
        “Historic” reflects the total cash back rewards that you’ve earned while using our
        platform.
      </>
    )
  },
  {
    question: 'How may I withdraw the money?',
    answer: (
      <>
        You can transfer⁴ your cashback funds to any card by simply going to “Redeem Cash
        Back”, selecting the amount you want to transfer, and following the steps on the screen.
      </>
    ),
    disclaimer: '⁴Third-party transfer fees may apply.'
  },
  {
    question: 'What purchases are not eligible for cashback?',
    answer: (
      <>
        Not all purchases are eligible for cashback. Each store reserves the right to exclude
        certain products or services from eligibility and users are subject to such exclusions. Make
        sure to read the offer’s description before making a purchase for more details.
      </>
    )
  }
]

const prepaidCardAcordionContent = [
  {
    question: 'Is Multikrd a bank?',
    answer: (
      <>
        No, Multikrd is a Financial Technology company. The Multikrd Prepaid Mastercard<sup>®</sup> is
        issued by Central Bank of Kansas City, Member FDIC.
      </>
    )
  },
  {
    question: 'When I apply, will you check my credit?',
    answer: (
      <>
        No, the Multikrd Card is a prepaid card, not a credit card and no credit check is required.
        Approval is subject to ID verification.
      </>
    )
  },
  {
    question: 'Is there a fee for getting a card?',
    answer: (
      <>
        No, there is no fee to apply. See the <a href='https://platform.accesswages.com/legal-agreements?section=Fee%20Schedules'>Fee Schedule</a> for complete details.
      </>
    )
  },
  {
    question: 'How do I apply for a card?',
    answer: (
      <>
        It is easy to apply! Simply log in into your account and click on the “Get your Multikrd
        Card” button and complete the application. Make sure all your information is correct, and
        you agree to all the documents.
      </>
    )
  },
  {
    question: 'Can I apply if I don’t have a Social Security number or ITN?',
    answer: (
      <>
        Yes, if you don’t have a SSN or ITIN, you will be asked to upload an image of your
        Unexpired Passport, Unexpired Matricula Consular ID, Unexpired Resident Alien ID, INE/Mexican
        Voter ID, or Foreign Government issued driver’s license.
      </>
    )
  },
  {
    question: 'How soon will I know if I’m approved?',
    answer: (
      <>
        Many applicants are approved right away. If your application requires additional
        information, you will be asked to answer a few questions.
      </>
    )
  },
  {
    question: 'How long does it take to receive my card?',
    answer: (
      <>
        Once you are approved, you will have immediate access to your virtual card. If you requested
        a physical card, it will arrive within 7-10 business days.
      </>
    )
  },
  {
    question: 'How do I activate my physical card?',
    answer: (
      <>
        Wait until your physical card is in your hands, login to your platform, and click on the
        green banner to activate your card and set your PIN. Don’t forget to add your physical card
        to your Google Wallet or Apple Wallet for easy access.        
      </>
    ),
    disclaimer: 'Google Wallet is a trademark of Google LLC. Apple and Apple Wallet are trademarks of Apple Inc., registered in the U.S.and other countries.'
  },
  {
    question: 'How do I add money to my card account?',
    answer: (
      <>
        Direct deposit: Get paid up to 2 days early¹ with direct deposit. Log in to your portal, go
        to the card menu and select direct deposit to access your account and routing numbers or
        complete the direct deposit form and give it to your employer.
        <br />
        <br />
        Load cash: Visit any Mastercard rePower<sup>®</sup> retailer to load cash² to your card. Service fees
        and balance/load limits may apply.
      </>
    ),
    disclaimer: (<>
      ¹We give you access to your direct deposits from employer and government payers on the day we receive them, which is typically up to 2 days earlier than your scheduled pay date.
      <br />
      <br />
      ²Service fee up to $5.95 applies. Balance and load limits apply.
    </>)
  },
  {
    question: 'Where do I check my balance?',
    answer: (
      <>
        You can check your account’s balance by logging into your portal and looking at your Home or
        Card tabs. The amount available on your card is always under the header “Available Balance”
        next to the image of your card. You can also see your transaction history and Earned Wage
        Access in the card menu.
      </>
    )
  },
  {
    question: 'Where can I use my card?',
    answer: (
      <>
        Use your card in-store and online everywhere Debit Mastercard is accepted. Additionally, you
        have access to over 40,000 fee-free MoneyPass<sup>®</sup> ATMs nationwide. You can geo-locate the
        nearest ATM from your login screen or the Card Management menu.
      </>
    )
  },
  {
    question: 'How can I transfer money from my card?',
    answer: (
      <>
        Send money to friends or family or pay bills using the “Send Money”³ option in the portal.
        Fees and limitations may apply. Consult the <a href='https://platform.accesswages.com/legal-agreements?section=Cardholder%20Agreement'>Cardholder Agreement and Fee Schedule</a> for
        complete details.
      </>
    ),
    disclaimer: '³Fees and limitations may apply. Consult the Cardholder Agreement and Fee Schedule for complete details.'
  },
  {
    question: 'What should I do if I lost my card, or it was stolen?',
    answer: (
      <>
        Go to “Card Management” inside your portal and lock your card right away to prevent
        unauthorized use. Call Customer Support toll-free at 1-866-995-2736 to report your card as
        lost/stolen and to order a new card. We are available 24/7/365.
      </>
    )
  },
  {
    question: 'Am I liable for unauthorized transactions?',
    answer: (
      <>
        You must contact us immediately by calling Customer Support at 1-866-995-2736 to notify us
        of any unauthorized use. For specific restrictions, limitations, and other details, please
        consult your <a href='https://platform.accesswages.com/legal-agreements?section=Cardholder%20Agreement'>Cardholder Agreement.</a>
      </>
    )
  },
  {
    question: 'Are my funds insured by the FDIC?',
    answer: (
      <>
        Multikrd Card funds are FDIC-insured through Central Bank of Kansas City. FDIC insurance
        limitations apply. Visit <a href='https://www.fdic.gov/deposit/deposits/prepaid.html'>fdic.gov/deposit/deposits/prepaid.html</a> for more details.
      </>
    )
  }
]

const payrollCardAcordionContent = [
  {
    question: 'What is the Multikrd Payroll Card?',
    answer: (
      <>
        The Multikrd Payroll Mastercard<sup>®</sup> is a convenient way for employees to receive their wages
        directly onto a card—no paper checks, no need for a traditional bank account.
      </>
    )
  },
  {
    question: 'Is Multikrd a bank?',
    answer: (
      <>
        No, Multikrd is a Financial Technology company. The Multikrd Payroll Mastercard is issued
        by Central Bank of Kansas City, Member FDIC.
      </>
    )
  },
  {
    question: 'How do I get a Payroll Card?',
    answer: (
      <>
        Only your employer can provide a Multikrd Payroll Card. If your company offers this
        benefit, you’ll receive your card from your HR or payroll department—no need to apply.
      </>
    )
  },
  {
    question: 'How do I activate my card?',
    answer: (
      <>
        Once you receive your physical card, log in to your Multikrd account, go to your Home
        screen, and follow the instructions to activate your card and set your PIN.
      </>
    )
  },
  {
    question: 'Is there a fee for getting a Payroll Card?',
    answer: (
      <>
        No, there is no fee to receive your Payroll Card through your employer. See the <a href='https://platform.accesswages.com/legal-agreements?section=Fee%20Schedules%20'>Fee Schedule</a> for full details on usage-related fees.
      </>
    )
  },
  {
    question: 'Is this the same as the Multikrd Prepaid Mastercard?',
    answer: (
      <>
        No, the Payroll Card and the Prepaid Card are two different products, and you cannot have
        both at the same time.
      </>
    )
  },
  {
    question: 'Can I receive money from other people or services on this card?',
    answer: (
      <>
        No. Only your employer can deposit money onto your Payroll Card via direct deposit. It does
        not support transfers from other sources.
      </>
    )
  },
  {
    question: 'Can I use Earned Wage Access with this card?',
    answer: (
      <>
        Yes!If your employer enables it, you can access a portion of your earned wages¹ before
        payday on your Payroll Card. Log in and go to the EWA section in your portal to request
        your available earnings.
      </>
    ),
    disclaimer: '¹Central Bank of Kansas City does not administer nor is liable for Pay on-demand/earned waged access or tips access.'
  },
  {
    question: 'How do I get paid on this card?',
    answer: (
      <>
        Your employer will deposit your wages directly to your Payroll Card each pay period. You may
        receive your pay up to 2 days early², depending on when the payroll file is submitted.
      </>
    ),
    disclaimer: '²We give you access to your direct deposits from employer and government payers on the day we receive them, which is typically up to 2 days earlier than your scheduled pay date.'
  },
  {
    question: 'Can I load cash or receive other deposits on this card?',
    answer: (
      <>
        No. The Multikrd Payroll Card is for employer direct deposits only. It does not support cash
        loading or incoming person-to-person transfers.
      </>
    )
  },
  {
    question: 'Where can I use my card?',
    answer: (
      <>
        You can use your Payroll Card everywhere Debit Mastercard is accepted—in stores, online, or
        at ATMs. You also have access to over 40,000 fee-free MoneyPass<sup>®</sup> ATMs across the country.
      </>
    )
  },
  {
    question: 'Can I add my card to a mobile wallet?',
    answer: (
      <>
        Yes! Once your physical card is activated, you can add it to your Apple Wallet or Google
        Wallet for easy access and secure payments.
      </>
    ),
    disclaimer: 'Google Wallet is a trademark of Google LLC. Apple and Apple Wallet are trademarks of Apple Inc., registered in the U.S. and other countries.'
  },
  {
    question: 'How do I check my balance?',
    answer: (
      <>
        Log in to your Multikrd portal or mobile app. Your Available Balance is displayed on the
        Home and Card tabs. You can also view recent transactions and any Earned Wage Access activity.
      </>
    )
  },
  {
    question: 'What if I lose my card or it gets stolen?',
    answer: (
      <>
        Go to Card Management in your portal to lock your card right away. Then call Customer
        Support at 1-866-995-2736 to report the loss and request a replacement. We're here to help
        24/7/365.
      </>
    )
  },
  {
    question: 'Are my funds FDIC insured?',
    answer: (
      <>
        Yes. Your Payroll Card funds are FDIC-insured through Central Bank of Kansas City. For more
        information, visit <a href='https://www.fdic.gov/deposit/deposits/prepaid.html'>fdic.gov/deposit/deposits/prepaid.html</a>.
      </>
    )
  },
  {
    question: 'Am I liable for unauthorized transactions?',
    answer: (
      <>
        If your card is lost or stolen, you must notify us immediately by calling 1-866-995-2736.
        Please review your Cardholder Agreement for full details on your protections and
        responsibilities.
      </>
    )
  }
]
